import { render, staticRenderFns } from "./AppStatusChip.vue?vue&type=template&id=b57726a2&scoped=true&"
import script from "./AppStatusChip.vue?vue&type=script&lang=js&"
export * from "./AppStatusChip.vue?vue&type=script&lang=js&"
import style0 from "./AppStatusChip.vue?vue&type=style&index=0&id=b57726a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57726a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
